<template>
<div class="np-srcselect trans-animate" ref="srcselect" 
	:class="{
		active:itemsShow,
		'np-srcselect-big':size==='big'
	}" 
	@click.stop.prevent="thisClick"
>	
	<input type="text" style="display: none;" v-model="value">
	<label class="np-srcselect-show" ref="srcselect_show">
		<slot name="icon" :valitem="words"></slot>
		<template v-for="(item,index) in multiVal" >
			<span  class="np-srcselect-show-item"
				:key="item"  v-if="!maxitems || (maxitems && index < maxitems) "
			> 			
				<em v-if="words[item]"  v-text="words[item].word"></em> 
				<i  @click.stop.prevent="deleteVal(item)" class="icon icon-close">&#xe678;</i>
			</span>
		</template>
		<span  class="np-srcselect-show-item"  v-show="maxitems &&  multiVal.length > maxitems">
			<em>+ {{multiVal.length - maxitems}}... </em>
		</span>
		<span v-if="srctype == 1" class="np-srcselect-show-input"  ref="srcselect_show_input">
			<input @input="srcList(valWord)"  @keyup.8 = "keydeleteItems" 
				v-model="valWord" type="text"
				@blur="getblurStr"
			>
			<!-- <em  v-text="valWord"></em> -->
		</span>
		<span v-else class="np-srcselect-show-input" style="min-width: 6px;"  ref="srcselect_show_input">
			<slot name="valstart" :item="words"></slot>
			<em v-text="valWord"></em>
		</span>
		<i  v-if="itemsShow && clearval" class="icon icon-arrdown" @click.prevent.stop="clearInput">&#xe678;</i>
		<i v-else class="icon vlm icon-arrdown" >&#xe62e;</i>
		
	</label>
	<div class="np-srcselect-list" v-show="itemsShow" :style="{top:inputHeight + 'px'}"  @click.stop>
		<div class="np-srcselect_childsrc" v-show="srctype == 2">
			<i class="icon icon-src">&#xe6b9;</i>
			<input @input="srcList(srcWord)" v-model="srcWord" type="text">
		</div>
		<div class="np-srcselect-list-wrap" v-if="srcItems.length || items.length">
			<template v-if="!!!srcItems.length && srcEnd">
				<label class="np-srcselect-list-item trans-animate" v-for="(v,i) in items" :key="i" @click="selected(v,i)"
					:class="{'np-srcselect-list-item_active':getActiveClass(v),'np-srcselect-list-item_disable':v.disable}"
				>
					<slot :item="{index:i,value:v}"></slot>
					<span class="np-srcselect-list-text" v-text="v.word"></span>
					<input :disabled="v.disable" v-model="multiVal" v-if="type" :value="v.real" type="checkbox">
				</label>
			</template>
			<template v-else>
				<template v-if="srcItems.length">
					<label class="np-srcselect-list-item trans-animate" v-for="(v,i) in srcItems" :key="i" @click="selected(v,i)"
						:class="{'np-srcselect-list-item_active':getActiveClass(v),'np-srcselect-list-item_disable':v.disable}"
					>
						<slot :item="{index:i,value:v}"></slot>
						<span class="np-srcselect-list-text" v-text="v.word"></span>
						<input :disabled="v.disable" v-model="multiVal" v-if="type" :value="v.real" type="checkbox">
					</label>
				</template>
				<template v-else>
					<p class="np-srcselect-nodata">
						<i class="icon">&#xe645;</i>
						No Data!
					</p>
				</template>
			</template>
		</div>
		<div v-else class="np-srcselect-nodata">
			<i class="icon">&#xe645;</i>
			No Data!
		</div>
	</div>
</div>
</template>

<script>
/* 
@功能描述
	1，模拟基本select功能，单选
	2，下拉多选  搜索功能
	3，设置不可选
	4，远程搜索
	5，联动
	
@@@参数说明@@@
	items: 初始化列表数据 值名称为:real 文字展示名称: word [{real:1,word:"word"}]
	maxcheck: type值为1，下拉为多选时起作用，最多可以选中几项
	value: v-model
	type: 1:多选  0:单选
	srctype：0:隐藏  1 直接搜索 2:下拉输入搜索 远程搜索此项必须为1 或者 2 默认0  
	maxitems:多选时，最多展示多少选项，多余项目以...展示
	remote 是否為遠程搜索結果
	单个数据中 设置选项不可选使用 disable:true
	
##@ 后期拓展功能 
	优化
		1，可以设置不清除选项
	翻页效果
*/
import _ from "underscore"
export default {
	name:"",
	props:["items","maxcheck","value","type","maxitems","srctype","remote","clearval","size","firstsrc"],
	data: function(){
		return {
			inputHeight: 0,
			valWord:"",
			srcWord:"",
			srcEnd:true,
			srcItems:[],
			words:{},
			itemsShow: false,
			val:"",
			multiVal:[]
		}
	},
	mounted: function(){
		var _this = this;
		this.$on("closeItems",this.closeItems);
		window.addEventListener("click",function(){
			_this.handleWinClick();
		});		
		this.setDefault();
		//首次载人执行 搜索
		if(this.firstsrc){
			this.srcList(this.firstsrc,true)
		}		
	},
	beforeDestroy() {
		window.removeEventListener('click', this.handleWinClick);
	},
	methods:{
		getblurStr: function(v){
			var _this = this;
			this.debounce(function(){
				if(v){
					try{
						let index = _this.$tools.inArray(_this.val,v,"real","index");
						if(index >= 0){
							_this.valWord = v[index].word;
						}else{
							_this.valWord = v[0].word;
						}						
					}catch(e){
						console.log(e)
					}					
				}else if(_this.words[_this.val]){
					_this.valWord = _this.words[_this.val].word;
				}
			},100)
		},
		clearInput: function(){
			this.valWord = "";
			this.val = "";
			this.multiVal = [];
			this.srcItems = [];
			this.srcEnd = true;
			this.itemsShow = false;
			this.setListHeight();
		},		
		keydeleteItems: function(){
			if(this.keyLength !== undefined){
				this.keyLength --;	
			}else{
				this.keyLength = -2;
			}			
			if(this.valWord === "" && this.keyLength<=-2 && this.multiVal.length){
				this.deleteVal(this.multiVal[this.multiVal.length - 1]);
			}
		},
		deleteVal: function(item){
			//删除对应项目
			var _this = this;
			this.multiVal = _.without(this.multiVal,item);
			this.$nextTick(function(){
				_this.setListHeight();
				_this.$refs.srcselect_show.focus();
			})			
		},
		closeItems: function(){	
			this.itemsShow = false;
		},
		handleWinClick: function(){
			this.$emit("closeItems");
		},
		thisClick: function(){			
			this.itemsShow = !this.itemsShow;
			if(this.itemsShow){
				this.$refs.srcselect_show.focus();
			}
		},		
		setDefault: function(v){	
			if(this.value){
				if(this.value instanceof Array){
					this.multiVal = this.value;
				}else{
					this.val = this.value;
					this.getblurStr(v);					
				}
			}
			this.setListHeight();			
		},
		srcList: function(keyword,first){				
			this.srcEnd = false;
			if(!first) this.itemsShow = true;						
			//设置keyLength长度
			this.keyLength =  keyword.length;
			//自动设置input长度	
			var _this = this;
			_this.$nextTick(function(){
				_this.setListHeight();
			});						
			this.search(keyword,first);
		},
		search: function(keyword,first){	
			var _this = this;
			var tmp = [];						
			for(var i = 0,len = _this.items.length;i<len;i++){
				if(_this.items[i].word.toLowerCase().indexOf(keyword.toLowerCase()) >= 0 ){
					tmp.push(_this.items[i]);
				}
			}
			if(!this.remote) return _this.srcItems = tmp;			
			//远程搜索	
			setTimeout(()=>{
				_this.debounce(function(){
					var keywords = _this.srctype == 2?_this.srcWord:_this.valWord;
					_this.$emit("search",{keywords:keywords,first,callBack:function(data){
						if(data && data instanceof Array){
							_this.srcItems = data;
						}
					}});		
				},"search_cleartime")	
			})		
		},
		debounce: function(fn,key,times){
			var wait = times || 500;
			if(typeof key === "number"){
				wait = key;
				key = "clearTime";
			}
			//防抖函数			
			if(this[key]){				
				this[key] = clearTimeout(this[key]);				
			}		
			this[key] = setTimeout(fn,wait);
		},
		selected: function(v){	
			if(v.disable){
				return;
			}
			this.srcWord = "";
			this.valWord = "";
			//this.srcItems = [];
			this.srcEnd = true;
			if(!this.type){
				this.val = v.real;
				this.valWord = v.word;
				this.itemsShow = false;				
			}
			this.$refs.srcselect_show.focus();
			this.$emit("selected",v)
		},
		getInputWidth: function(){
			var width = this.valWord.length * 7;
			var boxWidth = 360;
			if( width >= boxWidth - 10){
				width = boxWidth;
			}
			if(this.srctype !== 1) this.$refs.srcselect_show_input.style.width = width + "px";			
		},
		setListHeight: function(){
			//设置高度
			try{
				this.inputHeight = this.$refs.srcselect_show.offsetHeight;
				this.getInputWidth();	
			}catch(e){
				//TODO handle the exception
			}			
		},
		getActiveClass:function(v){
			if(this.type){
				for(var i = 0,len = this.multiVal.length; i<len; i++){
					if(this.multiVal[i] === v.real){
						return true;
					}
				}
			}else{
				if(this.val === v.real){
					return true;
				}
			}
		},
		maxmulti: function(){
			//限制最多选几个			
			if(this.multiVal.length  > this.maxcheck){
				this.multiVal.splice(this.multiVal.length - 2,1);
			}
		},
		getWord: function(wordsObj){
			//通过值获取 text
			for(var k in wordsObj){				
				for(var i = 0,len = this.items.length;i<len;i++){
					if(wordsObj[k] === this.items[i].real){
						wordsObj[k] = this.items[i];
						break; 
					}
				}
				if(!(wordsObj[k] instanceof Object)){
					for(var j = 0,slen = this.srcItems.length;j<slen;j++){
						if(wordsObj[k] === this.srcItems[j].real){
							wordsObj[k] = this.srcItems[j];
							break; 
						}
					}	
				}
				if(wordsObj[k] instanceof Object){
					this.words[k] = wordsObj[k];
				}
			}	
			//删除多余键
			for(var key in this.words){
				if(wordsObj[key] === undefined){
					delete this.words[key];
				}
			}
			this.$emit("getwordsobj",this.words);
		}
	},
	watch:{
		multiVal: function(v){
			var _this = this;
			this.maxmulti();
			this.$emit("input",v);
			this.$nextTick(function(){
				_this.setListHeight();				
			});			
			var words = _.object(v,v);
			this.getWord(words);			
		},
		val: function(v){				
				this.$emit("input",v);
				var words = _.object([v],[v]);
				this.getWord(words);
		},
		value: {			
			handler: function(){
				this.setDefault();					
			},
			immediate:true
		},
		items:{
			handler: function(v){
				this.setDefault(v);				
			},
			deep:true,
			immediate:true
		},
		srcWord: function(v){
			if(v === "" && !this.remote){
				this.srcItems = [];
			}			
		},
		valWord: function(v){
			if(this.srctype == 1){	
				this.val = v;
			}
		}
	}
}
</script>

<style lang="scss">
$selectHeight: $height-input;
$selectHeight-big: 40px;
.np-srcselect {
	box-sizing: border-box;	
	position: relative;
	display: inline-block;
	border: 1px solid $color-border-input;
	min-height: $selectHeight;
	border-radius: $border-radius-xs;
	z-index: 9;
	//搜索框样式
	&_childsrc {
		height:  $selectHeight * 0.9;
		padding: $space-padding-md $space-padding-sm;
		position: relative;
		input {
			height: 100%;
			box-sizing: border-box;
			width: 100%;
			padding-right: $space-padding-sm;
			padding-left: $space-padding-xl;			
			border: 1px solid $color-border-input;
			border-radius: $border-radius-xs;
		}
		.icon-src {
			position: absolute;
			font-size: $font-size-sm;
			color: $color-gray;
			top: 50%;
			left: $space-padding-md + calc($space-padding-xs / 2);
			-webkit-transform: translateY(-50%);
			-ms-transform: translateY(-50%);
			-moz-transform: translateY(-50%);
			transform: translateY(-50%);			
		}
	}
	&.active {
		border-color: $color-border-main;
		.np-srcselect-list {
			border-color: $color-border-main;
		}
	}
	//np-srcselect-nodata
	&-nodata {
		text-align: center;
		padding: $space-padding-bs 0;
		color: $color-disable;
		.icon {
			display: block;
			font-size: 2.6rem;
			padding-bottom: $space-padding-sm;
		}
	}
	//np-srcselect-show
	&-show {		
		min-width: 80px;
		line-height: $selectHeight - 2;		
		display: block;
		font-size: 0;
		padding-right: $space-padding-sm * 3;
		white-space: nowrap;
		.icon-arrdown {
			position: absolute;
			right: $space-padding-sm;
			font-size: $font-size-xs;
			color: $color-gray;
			cursor: pointer;
			top: 50%;
			transform: translateY(-50%) scale(0.8);
			-webkit-transform: translateY(-50%) scale(0.8);
			-moz-transform: translateY(-50%) scale(0.8);
		}
		input {
			height: 100%;
			background: none;
			border: 0;
			outline: none;
			width: 100%;			
		}
		//np-srcselect-show-list
		&-list {
			box-sizing: border-box;
			display: inline-block;
			vertical-align: middle;
			height: $selectHeight * 0.7;
			line-height: $selectHeight * 0.7;
			font-size:0;
		}
		//np-srcselect-show-item
		&-item {
			display: inline-block;
			background-color: $color-bg-md;
			padding: 0 $space-padding-sm;
			border-radius: $border-radius-xs;			
			margin-left: $space-padding-xs;
			font-size: $font-size-md;
			height: $selectHeight * 0.7;
			line-height: $selectHeight * 0.7;
			vertical-align: middle;
			.icon-close {
				display: inline-block;
				cursor: pointer;
				color: $color-gray;
				font-size: $font-size-sm;
				transform: scale(0.8);				
			}
		}
		//np-srcselect-show-input
		&-input {
			cursor: pointer;
			min-width: 90px;
			margin-left: $space-margin-sm;
			display: inline-block;
			box-sizing: border-box;
			vertical-align: middle;
			font-size: $font-size-md;
			height: $selectHeight * 0.7;
			line-height: $selectHeight * 0.7;
		}
	}
	//np-srcselect-list
	&-list{
		position: absolute;
		top:  $selectHeight - 2;
		left: -1px;		
		background-color: $color-bg-bs;
		box-shadow: 0 0 $space-padding-sm rgba(0,0,0,0.1);
		border: 1px solid $color-border-input;
		width: 100%;		
		//np-srcselect-list-wrap
		&-wrap {
			max-height: 300px;
			overflow: auto;
			&::-webkit-scrollbar {
				width: 4px; 
			}
			&::-webkit-scrollbar-thumb {
				width: 4px;
				border-radius: 4px;
				background: rgba(0,0,0,0.3); 
			}
		}
		//np-srcselect-list-text 
		&-text {
			display: inline-block;
			vertical-align: middle;
			margin-left: $space-padding-xs;
		}
		//np-srcselect-list-item
		&-item {
			height: $selectHeight * 0.9;
			line-height: $selectHeight * 0.9;
			padding: 0 $space-padding-xs;
			display: block;
			position: relative;
			overflow: hidden;
			input {
				position: absolute;
				opacity: 0;
				height: 100%;
				width: 100%;
				z-index: 9;
				cursor: pointer;
			}
			&:hover {
				background-color: $color-bg-md;
				cursor: pointer;
			}
			&_active {				
				&::before {
					content: "";
					margin-right: 5px;
				}				
			}
			//np-srcselect-list-item_disable
			&_disable {			
				cursor: no-drop !important;
				color: $color-gray;
				&:hover {
					background-color: $color-bg;
				}
				input {
					cursor: no-drop !important;
				}
			}
			&::before {
				display: inline-block;
				vertical-align: middle;
				width: 8px;
				height: 4px;
				top: 50%;				
				-webkit-transform: rotate(-45deg);
				-moz-transform: rotate(-45deg);
				-ms-transform: rotate(-45deg);
				transform: rotate(-45deg);
				border-bottom: 2px solid $color-border-main;
				border-left: 2px solid $color-border-main;				
			}			
		}
	}	
}
//尺寸大小
.np-srcselect-big {
	min-height: $selectHeight-big;
	.np-srcselect-show {
		line-height: $selectHeight-big;
	}
}
</style>
